import React from 'react'
import './Footer.css'

const Footer = () => {
  return (
    <footer>
        <p>&copy;2022 Khingz, All RIghts Reserved</p>
    </footer>
  )
}

export default Footer